import { render, staticRenderFns } from "./companies-emisores.vue?vue&type=template&id=42d63210"
import script from "./companies-emisores.vue?vue&type=script&lang=js"
export * from "./companies-emisores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports